import { StyledTable, StyledHeadCell } from 'baseui/table-grid'
import RowsRequestTable from '../RowsRequestTable/RowsRequestTable'
import { Notification } from 'baseui/notification'
import useModalExportLogsTable from './useModalExportLogsTable'

const ModalExportLogsTable = ({ data }) => {
  const { css, t, dataEmpty, rows } = useModalExportLogsTable({ data })

  if (dataEmpty) {
    return (
      <Notification
        overrides={{
          Body: {
            style: {
              width: 'auto',
              color: 'rgb(20, 96, 170)',
              backgroundColor: 'rgb(233, 242, 251)',
            },
          },
        }}
      >
        {() => t('subscriptionForm:subscription_actions_module.export_logs.no_export_logs_result')}
      </Notification>
    )
  }

  return (
    <div
      className={css({
        height: 'auto',
      })}
    >
      <StyledTable role='grid' $gridTemplateColumns='auto auto auto auto auto'>
        <div role='row' className={css({ display: 'contents' })}>
          <StyledHeadCell>
            {t('subscriptionForm:subscription_actions_module.export_logs.head_direction_text')}
          </StyledHeadCell>
          <StyledHeadCell>
            {t('subscriptionForm:subscription_actions_module.export_logs.head_workflow_used_text')}
          </StyledHeadCell>
          <StyledHeadCell>
            {t('subscriptionForm:subscription_actions_module.export_logs.head_message_type_text')}
          </StyledHeadCell>
          <StyledHeadCell>
            {t('subscriptionForm:subscription_actions_module.export_logs.head_date_text')}
          </StyledHeadCell>
          <StyledHeadCell>
            {t('subscriptionForm:subscription_actions_module.export_logs.head_content_text')}
          </StyledHeadCell>
        </div>

        {rows.map(({ index, item, striped }) => {
          return (
            <>
              <RowsRequestTable
                isSentRequest
                striped={striped}
                workflowName={item.workflow_name}
                description={item.description}
                requestDate={item.request_sent.date}
                requestData={item.request_sent.params}
                requestUrl={item.request_sent.url}
                index={index}
                id={item.id}
              />
              <RowsRequestTable
                isSentRequest={false}
                striped={striped}
                workflowName={item.workflow_name}
                description={item.description}
                requestDate={item.request_response.date}
                requestData={item.request_response.response}
                index={index}
                id={item.id}
              />
            </>
          )
        })}
      </StyledTable>
    </div>
  )
}

export default ModalExportLogsTable
